import { VFC } from 'react'
import { attentionColor, truewhite } from 'src/styles/colors'
import { flexCenter } from 'src/styles/mixins'
import styled from 'styled-components'
import { ALERT_BANNER_HEIGHT, AlertBannerCss } from './common'

const text = (salesDemoDaysLeftText: number) =>
  `デモアカウントでは一部機能が制限されます。予めご了承ください。 デモアカウントの有効期限は${salesDemoDaysLeftText}です。`

type SalesDemoAlertBannerProps = {
  salesDemoDaysLeftText: number
}

export const SalesDemoAlertBanner: VFC<SalesDemoAlertBannerProps> = ({
  salesDemoDaysLeftText,
}) => (
  <SalesDemoAlertDiv>
    <p>{text(salesDemoDaysLeftText)}</p>
  </SalesDemoAlertDiv>
)

const SalesDemoAlertDiv = styled.div`
  line-height: ${ALERT_BANNER_HEIGHT};
  width: 100%;
  ${flexCenter}
  background-color: ${attentionColor};
  color: ${truewhite};
  text-align: center;
`

export const FixedSalesDemoAlertBanner: VFC<SalesDemoAlertBannerProps> = ({
  salesDemoDaysLeftText,
}) => (
  <FixedSalesDemoAlertDiv>
    <p>{text(salesDemoDaysLeftText)}</p>
  </FixedSalesDemoAlertDiv>
)

const FixedSalesDemoAlertDiv = styled.div`
  ${AlertBannerCss}
  background-color: ${attentionColor};
  color: ${truewhite};
  text-align: center;

  @media screen and (max-width: 960px) {
    display: none;
  }
`
